module.exports = __webpack_public_path__ + "img/checkmark.53f1c079.svg";